module.exports = "/images/vendor/flag-icon-css/flags/4x3/ma.svg?60fbc221d84de9fb44f0d70882a393fc";